
// Méthode pour adapter les titres des colonnes à des noms de propriétés.
import {Identifiable} from "../model/interface/Identifiable";

export const arrayIndexFormat = (str: string): string => {
    return str.replace(/ /g, '_').toLowerCase();
};

export const extractIdFromIri = (iri: string | Identifiable | null): string => {
    if (!iri) {
        return '';
    }
    if (typeof iri === 'string') {
        return iri.split('/').at(-1) ?? '';
    }
    return iri.id?.toString() ?? '';
};

export const parseInlineStyle = (style: string) => {
    const template = document.createElement('template');
    template.setAttribute('style', style)
    return Object.entries(template.style)
        .filter(([ key ]) => !/^[0-9]+$/.test(key))
        .filter(([ , value ]) => Boolean(value))
        .filter(([ , value ]) => value !== 'initial')
        .reduce((acc, [ key, value ]) => ({ ...acc, [key]: value }), {});
}
